// DataTable.js
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Table, Button, Divider, Spin, message, Modal, Form, Upload, Input, Select, Image, Space, Popconfirm, Tooltip, Card, Carousel, Typography,Empty } from 'antd';
import WebLinks from '../../../api/WebLinks';
import { UploadOutlined, PlayCircleOutlined,DeleteOutlined,EditOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import constants from '../../../constants/constants';
import { CommonContext } from '../../../Context';
import APIUtils from '../../../api/APIUtils';
const { Paragraph } = Typography;

const LandingPages = () => {
    const [Loading,setLoading]=useState(false);
    const [NewModalOpen,setNewModalOpen]=useState(false);
    const [updateRecord,setUpdateRecord]=useState(false);
    const [data,setData]=useState([]);
    const [form] = Form.useForm();
    const [pagination, setPagination] = useState({
      current: 1,
      pageSize: constants.pageSize,
      total: 0,
    });
    const [sorter, setSorter] = useState({
      field: 'Occupation',
      order: 'ascend',
    });
    const columns = [
      {
        title: 'Landing Page URL',
        dataIndex: 'landingPageURL',
        key: 'landingPageURL',
        sorter: true
      },
      {
        title: 'Occupation',
        dataIndex: 'occupation',
        key: 'occupation',
        sorter: true
      },
      {
        title: 'Location',
        dataIndex: 'location',
        key: 'location',
        sorter: true
      },
      {
        title: 'Campaign',
        dataIndex: 'campaign',
        key: 'campaign',
        sorter: true
      },
      {
        title: 'Monthly Budget',
        dataIndex: 'monthlyBudget',
        key: 'monthlyBudget',
      },
      {
        title: 'Actions',
        key: 'actions',
        align: 'center',
        render: (text, record) => (
          <Space>
            <Button type="primary" size='small' onClick={() => handleUpdate(record.id)} icon={<EditOutlined />}/>
            <Popconfirm
              title="Are you sure to delete this record?"
              onConfirm={ () => handleDelete(record.id)}
              okText="Yes"
              cancelText="No"
            >
                <Button type="primary" danger size='small' icon={<DeleteOutlined />}/>
            </Popconfirm>
          </Space>
        ),
      },
    ];

    const commonContext=useContext(CommonContext);
    const buyerId = commonContext.common.buyerId;

    const handleUpdate = (id) => {
      const editRecord = data.find((row)=> row.id===id);
      setUpdateRecord(editRecord);
      setNewModalOpen(true);
      form.setFieldsValue({
        monthlyBudget:editRecord.monthlyBudget,
        occupation:editRecord?.occupation||null,
        location:editRecord.location,
        campaign:editRecord.campaign,
        landingPageUrl:editRecord.landingPageURL,
      })
    };

    const handleDelete = async(id) => {
      setLoading(true);
      const response = await APIUtils.apiCall('DELETE',WebLinks.DeleteLandingPageSettings+id,null,true,false);
      if(!response.isCatch && response.resultObj.statusCode==="2000"){
         getData(pagination.current);
         message.success(response?.resultObj?.message || "Deleted record successfully");
      }else{
          message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
      }
      setLoading(false);
    };

    const getData = async()=>{
      setLoading(true);
      let desc = sorter.order === 'descend' ? "true" : "false";
      const response = await APIUtils.apiCall('GET',WebLinks.GetLandingPageSettings+"buyerId="+buyerId+"&limit="+pagination.pageSize+"&pageNo="+pagination.current+"&orderBy="+sorter?.field +"&sortDesc="+desc,null,true,false);
      if(!response.isCatch && response.resultObj.statusCode==="2000"){
          setData(response?.resultObj?.data);
          setPagination((prev) => ({
            ...prev,
            total: response?.resultObj?.getCount || 0,
          }));
      }else{
          setData([]);
      }
      setLoading(false);
    };

    const handleCancel = () => {
      form.resetFields();
      setNewModalOpen(false);
      if(updateRecord){
        setUpdateRecord(null);
      }
    };

    const onFinish = async (values) => {
      saveConfig(values);
    };

    const saveConfig=async (values)=>{
      if(!values?.occupation?.toString() && !values.location){
        form.setFieldsValue({
          occupation: null,
          location:null,
        })
        message.error("Please enter either an occupation or a location.")
      }
      else{
      let payload = null;
      payload = {  
        buyerId: buyerId,
        location: values.location,
        monthlyBudget: values.monthlyBudget,
        campaign: values.campaign,
        landingPageURL: values.landingPageUrl,
        occupation: values.occupation
      }
      if(updateRecord){
        payload.id = updateRecord.id;
      }
      try {
        let url= updateRecord?WebLinks.UpdateLandingPageSettings:WebLinks.AddLandingPageSettings;         
          const response = await APIUtils.apiCall(updateRecord?'PUT':'POST', url, JSON.stringify(payload));         
          if (!response.isCatch && response.resultObj.statusCode === "2000") {
            message.success(response?.message || "Added record successfully");
            handleCancel();
            getData(pagination.current);
          } else {
              message.error(response?.message || constants.ERROR_MESSAGE);
          }
        } catch (error) {
          console.error('Error uploading image:', error);
      } 
       } 
    }

    const handleTableChange = (pagination, filters, sorter) => {
      setPagination(pagination);
      if(sorter?.field!==undefined){
        setSorter(sorter);
      }
    };

    useEffect(()=>{
        getData();
    },[pagination.current, pagination.pageSize, sorter.field, sorter.order]);

    return(
    <div>
      <Spin spinning={Loading}>
        <div className='flex flex-wrap justify-between items-center'>
          <div className='uppercase font-bold text-xl'>Social Media Promo Configuration</div>
          <div>
            <Button type="primary" style={{ marginRight: '10px' }} onClick={async () => {
                setNewModalOpen(true);
            }}>
                Add New
            </Button>
          </div>
        </div>
        <Divider className='my-3' />
        <Table scroll={{ x: '1000' }} sortDirections={['descend', 'ascend', 'descend']} columns={columns} dataSource={data} pagination={pagination} onChange={handleTableChange}/>
        <Modal
          title={updateRecord?"Edit Landing Page":"Add Landing Page"}
          open={NewModalOpen}
          onCancel={handleCancel}
          destroyOnHidden={true}
          okText={<span className="capitalize">Save</span>}
          onOk={() => form.submit()}
          style={{ top: 20 }}
          width={800}
        >
          <Form form={form} name="form_in_modal" layout="vertical" onFinish={onFinish}>
              <Form.Item
                  name="landingPageUrl"
                  label="LandingPageURL"
              >
                  <Input/>
              </Form.Item>
               <Form.Item
                  name="occupation"
                  label="Occupation"
              >
                  <Input/>
              </Form.Item>
              <Form.Item
                name="location"
                label="Location"
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="campaign"
                label="Campaign"
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="monthlyBudget"
                label="Monthly Budget"
              >
                <Input />
              </Form.Item>
          </Form>
        </Modal>
      </Spin>
  </div>
    );
};

export default LandingPages;
